import { z } from 'zod';

export const BlockedDomains = z.object({
  id: z.number(),
  accountId: z.string().max(50),
  domain: z.string().email(),
  createdAt: z.date(),
});

export type BlockedDomainsDto = z.infer<typeof BlockedDomains>;

export const CreateBlockedDomainsSchema = BlockedDomains.omit({
  id: true,
  accountId: true,
  createdAt: true,
});
export type CreateBlockedDomainsDto = z.infer<typeof CreateBlockedDomainsSchema>;
